import { useEffect, useState } from 'react';
import { kfClient, MeResponse } from '../kf-client';

// Re-export for tests/consumers that referenced the old inline type.
export type { MeResponse };

const ROLE_LABELS: Record<number, string> = {
  0: 'guest',
  1: 'viewer',
  2: 'operator',
  3: 'admin',
  4: 'root',
};

type State =
  | { kind: 'loading' }
  | { kind: 'ok'; me: MeResponse }
  | { kind: 'err'; msg: string };

export function UserIdentity() {
  const [state, setState] = useState<State>({ kind: 'loading' });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const me = await kfClient.me();
        if (cancelled) return;
        setState({ kind: 'ok', me });
      } catch (e) {
        if (cancelled) return;
        setState({ kind: 'err', msg: (e as Error).message });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (state.kind === 'loading') {
    return <span className="user-identity user-identity-loading" aria-live="polite">…</span>;
  }
  if (state.kind === 'err') {
    return (
      <span className="user-identity user-identity-err" title={`/api/me failed: ${state.msg}`}>
        identity unavailable
      </span>
    );
  }
  const roleLabel = ROLE_LABELS[state.me.role] ?? `role-${state.me.role}`;
  return (
    <span className="user-identity" title={`Tenant ${state.me.tenantId} · user ${state.me.userId} · role ${state.me.role}`}>
      <span className="user-identity-user mono">{state.me.userId}</span>
      <span className="user-identity-sep"> · </span>
      <span className="user-identity-role">{roleLabel}</span>
    </span>
  );
}
